import { BreakpointOverrides } from '@mui/system';

export const breakpoints: BreakpointOverrides = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1400,
  },
};
